import React from "react"
import { Link } from "gatsby"

const Locations = ({ routeParams }) => (
  <div className="locations-container">
    <div className="title-header">
      <h3 className="font-syne font-bold">LOCATIONS</h3>
    </div>

    <ul className="font-montserrat-13">
      {routeParams?.location.includes("sydney") && (
        <>
          <li>
            <div className="link">
              <Link to="/au/sydney/sydney-wedding-music-red-soda-band/">
                Sydney
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to="/au/sydney/southern-highlands-wedding-music-red-soda-band/">
                Southern Highlands
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to="/au/sydney/venues/blue-mountains-wedding-music-red-soda-band/">
                Blue Mountains
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to="/au/sydney/hunter-valley-wedding-music-red-soda-band/">
                Hunter Valley
              </Link>
            </div>
          </li>
        </>
      )}
      {routeParams?.location.includes("boston") && (
        <>
          <li>
            <div className="link">
              <Link to="/us/boston/locations/boston-wedding-band/">Boston</Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to="/us/boston/locations/Connecticut-wedding-band/">
                Connecticut
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to="/us/boston/locations/maine-wedding-band/">Maine</Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to="/us/boston/locations/massachusetts-wedding-band/">
                Massachusetts
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to="/us/boston/locations/new-england-wedding-band/">
                New England
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to="/us/boston/locations/new-hampshire-wedding-band/">
                New Hampshire
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to="/us/boston/locations/rhode-island-wedding-band/">
                Rhode Island
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to="/us/boston/locations/vermont-wedding-band/">
                Vermont
              </Link>
            </div>
          </li>
        </>
      )}
      {routeParams?.location.includes("toronto") && (
        <>
          <li>
            <div className="link">
              <Link to="/ca/toronto/toronto-wedding-band/">Toronto</Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to="/ca/toronto/ontario-wedding-band/">Ontario</Link>
            </div>
          </li>
        </>
      )}
      <li>
        <div className="link">
          <Link to="/us/boston/">America</Link>
        </div>
      </li>
      <li>
        <div className="link">
          <Link to="/au/sydney/">Australia</Link>
        </div>
      </li>
      <li>
        <div className="link">
          <Link to="/ca/toronto/">Canada</Link>
        </div>
      </li>
    </ul>
  </div>
)

export default Locations
